/**
 * Decode JWT payload (client-side only; signature verified by API).
 */
export function decodeToken(token) {
  try {
    if (!token) return null
    const parts = token.split('.')
    if (parts.length !== 3) return null
    const payload = parts[1]
    const normalized = payload.replace(/-/g, '+').replace(/_/g, '/')
    return JSON.parse(atob(normalized))
  } catch {
    return null
  }
}

export function isImpersonationToken(token) {
  const decoded = decodeToken(token)
  return Boolean(decoded?.impersonation)
}

export function getImpersonationMeta(token) {
  const decoded = decodeToken(token)
  if (!decoded?.impersonation) return null
  return {
    impersonatedBy: decoded.impersonatedBy || null,
    impersonationId: decoded.impersonationId || null,
    id: decoded.id ?? null,
    masterId: decoded.masterId ?? null,
  }
}
